// apps/dashboard/src/components/chrome/DashboardFooter.tsx
import { BUILD_TAG } from "@/lib/build";

export function DashboardFooter() {
  const websiteUrl =
    (import.meta.env.VITE_WEBSITE_URL as string | undefined) ?? "https://gated.cc";
  return (
    <footer className="border-t border-border-1 bg-bg-1">
      <div className="p-2 flex items-center justify-between text-tiny tracking-widest uppercase text-fg-3">
        <span>GATED · MCP-SEC · {BUILD_TAG}</span>
        <nav className="flex gap-4">
          <a
            href={`${websiteUrl}/docs`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-fg-1 transition-colors"
          >
            Docs
          </a>
          <a
            href={`${websiteUrl}/privacy`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-fg-1 transition-colors"
          >
            Privacy
          </a>
        </nav>
      </div>
    </footer>
  );
}
